module.exports = __webpack_public_path__ + "img/offer_img.261d0b76.png";